import { render, staticRenderFns } from "./mvv.vue?vue&type=template&id=caf5ae38&scoped=true&"
var script = {}
import style0 from "./mvv.vue?vue&type=style&index=0&id=caf5ae38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf5ae38",
  null
  
)

export default component.exports